import React, { useCallback, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { actionLogout } from "../../Store/slices/AuthSlice";
import { actionCount } from "../../Store/slices/NotificationSlice";
import { useGetNotificationMutation } from "../../Store/api/DataApi";
import { RootState } from "../../Store";
import { useLogOutMutation } from "../../Store/api/AuthApi";

export default function AccountSideBar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [getNotification, { data }] = useGetNotificationMutation();
  const [logout] = useLogOutMutation();
  const { auth } = useSelector((state: RootState) => state);
  const { count } = useSelector((state: RootState) => state.notification);

  const handleLogout = useCallback(() => {
    logout({ user_type: "candidate" }).then((res) => {
      dispatch(actionLogout());
      navigate("/", { replace: true });
    });
  }, [dispatch, navigate]);

  useEffect(() => {
    if (data?.data) {
      dispatch(actionCount(data?.data.total_unread_count));
    }
  }, [data]);

  const fetchNotification = useCallback(() => {
    let params = {
      user_type: "2",
      user_id: String(auth?.profile?.id),
      page: 1,
      limit: 6,
    };

    getNotification(params);
  }, [getNotification, auth?.profile?.id]);

  useEffect(() => {
    fetchNotification();
  }, []);

  useEffect(() => {
    if (!auth.token) {
      handleLogout();
    }
  }, [auth]);

  return (
    <div className="right-sideabr">
      <div className="inner-box">
        <h4>Manage Account</h4>
        <ul className="lest item">
          <li>
            <NavLink to="/resume">My Resume</NavLink>
          </li>
          <li>
            <NavLink to="/bookmarked">Bookmarked Jobs</NavLink>
          </li>
          <li>
            <NavLink to="/bookmarked-event">Bookmarked Event</NavLink>
          </li>
          <li>
            <NavLink to="/notifications">
              Notifications
              {count > 0 && <span className="notinumber">{count}</span>}
            </NavLink>
          </li>
        </ul>
        <h4>Manage Job</h4>
        <ul className="lest item">
          <li>
            <NavLink to="/manage-applications">Manage Applications</NavLink>
          </li>
          <li>
            <NavLink to="/job-alerts">Job Alerts</NavLink>
          </li>
        </ul>
        <ul className="lest">
          <li>
            <NavLink to="/applied-events">Events/Workshop</NavLink>
          </li>
          <li>
            <Link to="#" onClick={handleLogout}>
              Sign Out
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}
